/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LabourCode } from './LabourCode';
import {
    LabourCodeFromJSON,
    LabourCodeFromJSONTyped,
    LabourCodeToJSON,
} from './LabourCode';

/**
 * 
 * @export
 * @interface LabourCodesResponse
 */
export interface LabourCodesResponse {
    /**
     * 
     * @type {string}
     * @memberof LabourCodesResponse
     */
    claimNumber: string;
    /**
     * 
     * @type {string}
     * @memberof LabourCodesResponse
     */
    workPackageId: string;
    /**
     * 
     * @type {Array<LabourCode>}
     * @memberof LabourCodesResponse
     */
    labourCodes: Array<LabourCode>;
    /**
     * 
     * @type {any}
     * @memberof LabourCodesResponse
     */
    count: any | null;
}

/**
 * Check if a given object implements the LabourCodesResponse interface.
 */
export function instanceOfLabourCodesResponse(value: object): value is LabourCodesResponse {
    if (!('claimNumber' in value) || value['claimNumber'] === undefined) return false;
    if (!('workPackageId' in value) || value['workPackageId'] === undefined) return false;
    if (!('labourCodes' in value) || value['labourCodes'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function LabourCodesResponseFromJSON(json: any): LabourCodesResponse {
    return LabourCodesResponseFromJSONTyped(json, false);
}

export function LabourCodesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LabourCodesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claimNumber': json['claimNumber'],
        'workPackageId': json['workPackageId'],
        'labourCodes': ((json['labourCodes'] as Array<any>).map(LabourCodeFromJSON)),
        'count': json['count'],
    };
}

export function LabourCodesResponseToJSON(value?: LabourCodesResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'claimNumber': value['claimNumber'],
        'workPackageId': value['workPackageId'],
        'labourCodes': ((value['labourCodes'] as Array<any>).map(LabourCodeToJSON)),
        'count': value['count'],
    };
}

